<template>
  <div>
    <div class="d-flex align-center">
      <h3>Municipios com mais vendas</h3>
      <v-spacer></v-spacer>
    </div>

    <v-divider class="ma-2"></v-divider>
    <v-data-table
      :items="citiesSales"
      :loading="citiesloading"
      :headers="citiesHeaders"
      class="content-table"
      hide-default-footer
      loading-text="Buscando..."
      no-data-text="Sem registros"
    >
      <template v-slot:[`item.salesValue`]="{ item }">
        {{
          item.salesValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })
        }}
      </template>

      <template v-slot:footer class="ma-0 pa-0">
        <section class="ma-0 pa-0">
          <Pagination
              v-if="totalItems > pageSize"
              :currentPage="currentPage"
              :totalItems="totalItems"
              :page="page"
              :pageSize="pageSize"
              :totalPages="totalPages"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "CitiesDashResale",
  components: {Pagination},

  props: {
    filter: {
      resaleId: "",
      startDate: "",
      endDate: "",
    },
  },

  data() {
    return {
      citiesSales: [],
      page: 1,
      totalPages: 1,
      pageSize: 10,
      currentPage: 1,
      totalItems: 1,
      citiesHeaders: [
        {
          text: "Município",
          align: "center",
          value: "city",
        },
        {
          text: "Quantidade",
          align: "center",
          value: "salesQuantity",
          sortable: false,
        },
      ],
      headerProps: {
        sortByText: "Ordenar por",
      },
      citiesloading: false,
      apiService: new ApiService(),
    };
  },

  created() {
    this.getCitiesSales();
  },

  methods: {
    getCitiesSales() {
      this.citiesloading = true;
      this.apiService
        .post("dashresale/cities", { ...this.filter, page: this.page })
        .then((response) => {
          this.citiesSales = response.content.data;
          this.totalPages = response.content.pager.totalPages;
          this.currentPage = response.content.pager.currentPage;
          this.totalItems = response.content.pager.totalItems;
          this.citiesloading = false;
        })
        .catch(() => {
          this.citiesloading = false;
        });
    },


    async backPage() {
      this.page -= 1;
      await this.getCitiesSales();
    },

    async nextPage() {
      this.page += 1;
      await this.getCitiesSales();
    },
  },

  watch: {},
};
</script>

<style></style>
